import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'arrayToList', pure: false })
export class ArrayToList implements PipeTransform {
  public transform(value: any[]): string {
    return value.join('\n');
  }
}
